module.exports = __webpack_public_path__ + "img/profil-zamkniety.f437778a.jpg";